import { Component, Injector, OnInit } from '@angular/core';
import { MessagingService } from './shared/services/messaging-service/messaging.service';
import { UserDetailsService } from './shared/services/user-details.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'taskopadnewversion';

    constructor(public messagingService: MessagingService,private http: HttpClient) {
        
    }

    ngOnInit(): void {
        this.messagingService.requestPermission();
        let onFirstClick = async () => {
            try {
                const response = await firstValueFrom(this.http.get<any>('https://ipv4.jsonip.com/'));
                localStorage.setItem('userIp', response.ip);
              } catch (error) {
                console.error(error);
              }

            document.removeEventListener("click", onFirstClick);
          };
          document.addEventListener("click", onFirstClick);
    }
}
